import { useMemo, ReactElement } from 'react';
import { formatISO, startOfYear, endOfYear } from 'date-fns';
import { EnterpriseField } from 'components';
import { DateRangePeriodPicker, Visibility, VisibilityProps } from '../common';
import { columns } from './columns';
import { Row } from './types';
import { ReportTable } from 'components/ReportTable';
import { TableColumns } from '@ff-it/ui';
import { StateFilterField, TypeFilterField } from '../Filter';

const resolveColumns = (visibility: Visibility): TableColumns<Row> => {
  switch (visibility) {
    case 'GLOBAL':
      return columns;
    case 'LOCAL':
      // no agency
      return columns.slice(1);
    case 'LOCAL_MANAGED':
    case 'LOCAL_TYPE':
      // no agency, no bonuses
      return columns.slice(1, 8);
  }
};

export function Type({ visibility, ...props }: VisibilityProps): ReactElement {
  const url = `reporting/type/${visibility.toLowerCase()}${'type' in props ? `/${props.type}/` : '/'}`;

  const initialFilter = {
    date_from: formatISO(startOfYear(new Date()), { representation: 'date' }),
    date_to: formatISO(endOfYear(new Date()), { representation: 'date' }),
  };

  const columns = useMemo(() => {
    return resolveColumns(visibility);
  }, [visibility]);

  return (
    <ReportTable
      defaultFilter={initialFilter}
      url={url}
      columns={columns}
      filterFields={
        <div className="flex-column">
          <div className="d-flex flex-row">
            <DateRangePeriodPicker />
            {visibility === 'GLOBAL' && (
              <EnterpriseField
                name="agency"
                isMulti
                className="ml-1"
                defaultOptions
                placeholder="All agencies"
                simple
              />
            )}
          </div>
          <div className="d-flex flex-row">
            <StateFilterField />
            {visibility !== 'LOCAL_TYPE' && <TypeFilterField global={visibility === 'GLOBAL'} className="ml-1" />}
          </div>
        </div>
      }
    />
  );
}
